import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(
  (theme, { isKiteUser, isMobileMode } = {}) => ({
    deleteAllButton: {
      margin: isMobileMode ? '20px 10px 0 0' : '32px 10px 0 0',
    },
    bar: {
      display: 'flex',
      flexDirection: 'column',
      zIndex: 100,
      position: 'sticky',
      padding: '40px 26px 10px',
      marginInline: '-26px',
      backgroundColor: 'white',
      top: '80px',
      [theme.breakpoints.down('lg')]: {
        top: '70px',
      },
      [theme.breakpoints.down('md')]: {
        top: '54px',
        padding: '20px 12px 10px',
        marginInline: '-12px',
        marginBottom: theme.spacing(1),
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          top: '70px',
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          top: '54px',
          padding: '20px 12px 10px',
          marginInline: '-12px',
          marginBottom: theme.spacing(1),
        }),
      },
    },
    panel: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        alignItems: 'stretch',
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          flexDirection: 'column',
          alignItems: 'stretch',
        }),
      },
    },
    tabs: {
      [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(1),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          marginBottom: theme.spacing(1),
        }),
      },
    },
    tab: {
      textTransform: 'none',
      fontWeight: 700,
      fontSize: 14,
      lineHeight: '20px',
      letterSpacing: '0.1px',
      paddingInline: theme.spacing(4),
      paddingBottom: 0,
      borderBottom: `2px solid ${theme.palette.grey1}`,
      color: theme.palette.grey1,
      '&.Mui-selected': {
        color: isKiteUser ? theme.palette.primary2 : theme.palette.primary1,
      },
      [theme.breakpoints.down('md')]: {
        paddingInline: theme.spacing(1),
        flexBasis: '50%',
      },
    },
  }),
);
